import {
  Breadcrumbs,
  Typography,
  Link,
  Stack,
  TablePagination,
} from "@mui/material";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { useControleRecebimentoEpiListaViewModel } from "../../viewModels/controle_recebimento_epi_lista_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateGestaoRecebimentoEpiColumns } from "./columns";
import { Header } from "./components/header";
import { GestaoRecebimentoEpiModal } from "./components/gestao_recebimento_epi_modal";
import { GestaoRecebimentoEpi } from "../../../domain/models/gestao_recebimento_epi";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const ControleRecebimentoEpiLista = () => {
  const viewModel = useControleRecebimentoEpiListaViewModel();

  const columns = useMemo(() => {
    return GenerateGestaoRecebimentoEpiColumns({
      onActionEdit: viewModel.handleCadastroGestaoRecebimentoEpiModalOpenState,
      onActionDelete: viewModel.handleDeleteGestaoEpiModalOpenState,
    });
  }, [
    viewModel.handleCadastroGestaoRecebimentoEpiModalOpenState,
    viewModel.handleDeleteGestaoEpiModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="AddRounded"
                      size={25}
                      className="text-white"
                    />
                  }
                  onMouseDown={(e) => {
                    viewModel.handleCadastroGestaoRecebimentoEpiModalOpenState(
                      null,
                      true,
                    );
                    e.preventDefault();
                  }}
                >
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Gestão de EPI
          </Link>
          <Typography className="text-primary-green">
            Controle de Recebimento de EPI
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Controle de Recebimento de EPI
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2"></div>
          </div>
        </div>
        {viewModel.errorMessage !== undefined ? (
          <div className="w-full">
            <AlertError
              messageErro={viewModel.errorMessage}
              onTryAgain={viewModel.handleReload}
            />
          </div>
        ) : (
          <>
            <Header
              idsGestaoEpi={viewModel.filters.idsGestaoEpi}
              idsFornecedores={viewModel.filters.idsFornecedores}
              ca={viewModel.filters.ca}
              dataRecebimento={viewModel.filters.dataRecebimento}
              dataValidade={viewModel.filters.dataValidade}
              gestaoEpiDropdown={viewModel.gestaoEpiDropdown}
              fornecedoresDropdown={viewModel.fornecedoresDropdown}
              onGestaoEpiChange={viewModel.handleGestaoEpiChange}
              onFornecedoresChange={viewModel.handleFornecedoresChange}
              onCaChange={viewModel.handleCaChange}
              onDataRecebimentoChange={viewModel.handleDataRecebimentoChange}
              onDataValidadeChange={viewModel.handleDataValidadeChange}
              onClearFilters={viewModel.handleClearFilters}
            />

            <Stack spacing={0}>
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />

              <StyledDataGrid
                tableName="controle_recebimento_epi"
                disableColumnMenu={false}
                getRowId={(row: GestaoRecebimentoEpi) =>
                  row.idGestaoRecebimentoEpi
                }
                textSize="pequeno"
                columns={columns}
                loading={viewModel.loading}
                disableRowSelectionOnClick={true}
                rows={viewModel.gestaoRecebimentoEpiLista}
                rowCount={viewModel.gestaoRecebimentoEpiLista.length}
                getRowHeight={() => "auto"}
                pageSizeOptions={[10, 25, 50, 100]}
                paginationMode="server"
                paginationModel={{
                  page: viewModel.pagination.page,
                  pageSize: viewModel.pagination.rowsPerPage,
                }}
              />

              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />
            </Stack>
          </>
        )}
      </div>

      {/* Modals */}

      <GestaoRecebimentoEpiModal
        open={viewModel.gestaoRecebimentoEpiCadastroModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedGestaoRecebimentoEpi={viewModel.selectedRecebimentoEpi}
        gestaoEpiDropdown={viewModel.gestaoEpiDropdown}
        centroCustoDropdown={viewModel.centroCustoDropdown}
        fornecedoresDropdown={viewModel.fornecedoresDropdown}
        onClose={() =>
          viewModel.handleCadastroGestaoRecebimentoEpiModalOpenState(
            null,
            false,
          )
        }
        onSubmit={viewModel.handleCadastroGestaoRecebimentoEpiSubmit}
        handleDownloadFile={() => viewModel.handleDownloadFile()}
        onDeleteFile={() => viewModel.handleFileChange(1)}
      />

      <DeleteDialog
        open={viewModel.gestaoRecebimentoEpiDeleteModal}
        title="Você realmente deseja excluir este item?"
        onClose={() =>
          viewModel.handleDeleteGestaoEpiModalOpenState(null, false)
        }
        onDelete={() => viewModel.handleDeleteGestaoEpiSubmit()}
      />
    </>
  );
};
